import { Outlet } from 'react-router';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-muted/50 p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center space-y-2 text-center">
          <h1 className="text-3xl font-bold tracking-tighter text-primary">
            UniDom.az
          </h1>
          <p className="text-muted-foreground">
            Smart Dormitory Management System
          </p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
